__turbopack_context__.v({
  "content": "index-module__0-o3AW__content",
  "field": "index-module__0-o3AW__field",
  "toggle": "index-module__0-o3AW__toggle",
  "toggled": "index-module__0-o3AW__toggled",
  "wrapper": "index-module__0-o3AW__wrapper",
});
